import angular from 'angular';

let inject = ['$scope', '$uibModalInstance', 'product', '$window'];

class ModalQuantityCartController {
    constructor($scope, $uibModalInstance, product, $window) {
        this.$scope = $scope;
        this.product = angular.copy(product);
        this.$window = $window;
        this.$uibModalInstance = $uibModalInstance;
        this.itemQuantityToAdd = 1;
        this.user = {};
    }

    ProductQuantity() {
      this.itemQuantityToAdd = parseInt(this.itemQuantityToAdd)
    }

    increaseItemQuantityToAdd() {
        if (!this.itemQuantityToAdd)
            this.itemQuantityToAdd = 1;
        else
            this.itemQuantityToAdd++;
    };

    decreaseItemQuantityToAdd() {
        if (!this.itemQuantityToAdd)
            this.itemQuantityToAdd = 1;
        else if (this.itemQuantityToAdd > 1) {
            this.itemQuantityToAdd--;
        }
    };

    addItemToCart(product, quantity) {
        this.$uibModalInstance.close({product: product, quantity: quantity});
        console.log(product);
        this.$window.dataLayer.push({
          'event': 'addToCart',
          'ecommerce': {
            'add': {
              'products': [{                        //  adding a product to a shopping cart.
                'name': product.name,
                'id': product.id,
                'price':  product.currentPrice,
                'category': product.category.slug,
                'quantity': quantity
              }]
            }
          }
        });
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }
}

ModalQuantityCartController.$inject = inject;

export default ModalQuantityCartController;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/modal-quantity-cart/modal-quantity-cart.controller.js
 **/